import { render, staticRenderFns } from "./mobile-promotion.note.vue?vue&type=template&id=2fcaac1e&scoped=true"
var script = {}
import style0 from "./mobile-promotion.note.vue?vue&type=style&index=0&id=2fcaac1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcaac1e",
  null
  
)

export default component.exports